import { Navigate, Outlet } from "react-router-dom";

import { isGated } from "~/lib/membership";
import { useAuthStore } from "~/store/auth-store";

/**
 * Layout route wrapping the entire shell: a signed-in non-member is redirected to
 * the standalone paywall — without a membership there is no app chrome to browse,
 * only the shop. Deep links land here first, so they bounce the same way.
 *
 * A courtesy, like the admin panel's gate — the API re-checks membership on every
 * request. It requires positive entitlement (see `isGated`), and the API client's
 * 403 handler downgrades stale cached access if the server disagrees.
 */
export function MemberGate() {
  const user = useAuthStore((state) => state.user);
  return isGated(user) ? <Navigate to="/paywall" replace /> : <Outlet />;
}
